export default "__VITE_ASSET__DJ48DIEO__"